import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '@wa/shared';
import { AdminShell } from '@/app/AdminShell';
import { LoginPage } from '@/pages/LoginPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { TenantsPage } from '@/pages/TenantsPage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { ChannelsPage } from '@/pages/ChannelsPage';
import { PricingPage } from '@/pages/PricingPage';
import { TemplatesPage } from '@/pages/TemplatesPage';
import { BotsPage } from '@/pages/BotsPage';
import { ErrorsPage } from '@/pages/ErrorsPage';
import { JobsPage } from '@/pages/JobsPage';
import { AuditPage } from '@/pages/AuditPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { StaffPage } from '@/pages/StaffPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';

export function App() {
  const { user, isBootstrapping } = useAuth();

  if (isBootstrapping) {
    return <div className="grid h-full place-items-center text-body text-(--color-muted)">Loading…</div>;
  }

  if (!user) {
    // The reset link lands here signed out, which is the only state anybody
    // following it is ever in.
    return (
      <Routes>
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/channels" element={<ChannelsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/bots" element={<BotsPage />} />
        <Route path="/errors" element={<ErrorsPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/staff" element={<StaffPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}
